import { render, staticRenderFns } from "./FactsListFilter.vue?vue&type=template&id=0f9638b8&"
import script from "./FactsListFilter.vue?vue&type=script&lang=js&"
export * from "./FactsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports